import request from '@/utils/request'


// 机构列表
export const getOrglist = (params) => {
  return request.get('/assistBusiness/listAssistBusiness', params)
}
// 服务列表
export const getServelist = (params) => {
  return request.get('/assistBusiness/info', params)
}
// 订单详情
export const getServeInfo = (params) => {
  return request.get('/assistServiceItems/info', params)
}
// 查询服务类型
export const assistServiceType = (id) => {
  return request.get(`/assistServiceType/info/${id}`)
}
// 服务列表
export const getServiceItems = (params) => {
  return request.get(`/assistServiceItems/info`,params)
}

// 人脸认证
export const verifyImg = (params) => {
  return request.get('/ynjmgc/app/verify', params)
}
// 人脸上传
// export const getCheckImg = (params) => {
//   return request.post('/ynjmgc/app/getCheckImg', params)
// }
export const getCheckImg = (params) => {
  return request.post('/assistBenefitImgCheckRecord/checkImg', params)
}
// 地址数据
export const getInfoByIdcard = (params) => {
  console.log(params)
  return request.get('/assistBenefitImgCheckRecord/getInfo',params)
}